import React from 'react';
import { WorkPageLayout } from '../Layout';
import { Link } from 'react-router-dom';
import styles from './Guide.module.scss';

export const GuideStepFour = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.guideLeftSection}>
        <span className={styles.guideStepLeft_1}>The</span>
        <span className={styles.guideStepLeft_2}>Guide</span>
        <span className={styles.guideStepLeft_3}>to a sustainable</span>
        <span className={styles.guideStepLeft_4}>technological</span>
        <span className={styles.guideStepLeft_5}>future</span>
      </div>
    }
    rightContent={
      <div className={styles.guideStepContentWrapper}>
        <ul style={{ marginBottom: 10 }}>
          <li style={{ marginBottom: 10 }}>
            An audience of experts, passionate conscious individuals, and sustainable companies make
            TransparenTerra the right place to develop your ideas and build a local, sustainable
            community.
          </li>
          <li style={{ marginBottom: 10 }}>
            Expert consultations and our digital solutions are tailored to your needs and help to
            develop solutions that improve the traceability and sustainability of your company or
            project.
          </li>
          <li>
            The TransparenTerra blockchain is environmentally friendly. FCE Group designed its
            technical developments to make a minimal impact on the environment, and compensates for
            shortfalls by buying CO2 offset certificates.
          </li>
        </ul>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Link to="/join" className={styles.guideButton}>
            Choose Your Role
          </Link>
        </div>
      </div>
    }
  />
);
